// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("BonnerCountyLogo-75.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("BonnerCountyLogo-45.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://js.arcgis.com/5.0/@arcgis/core/assets/esri/themes/light/main.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: rgb(246, 246, 246);
}

#parent-div{
    width: 80vw;
    margin: auto;
}

#header {
    background-color: #325674;
    height: 15vh;
    display: flex;
    align-items: center;
}

.header-title{
    color: white;
    margin: 0;
    font-size: 24px;
    font-weight: bold;
}

.header-subtitle{
    color: white;
    margin: 0;
    font-size: 20px;
}

#header h1, h4{
    color: white;
    margin: 0;
}

.bc-logo {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-left: 20px;
    margin-right: 50px;
}

#disclaimer-div{
    border: 1px solid rgb(219, 219, 219);
    padding: 0 10px;
    margin: 5px 0;
    font-size: 14px;
}

#last-updated-div{
    font-size: 10px;
    font-style: italic
}

#btn-export{
    color: blue;
    font-weight: bold;
    font-size: 14px;
}

#btn-export:hover{
    text-decoration: underline;
    cursor: pointer;
}

/* main[role=main]{
    margin: auto;
    width: 60vw;
} */

#mainContent-inner {
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(140, 140, 140);
    padding: 10px;
    min-height: 500px;
    overflow-y: auto;
    max-height: 65vh;
}

.grid-container{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 5px;
}

#mainContent-inner>div:nth-child(odd){
    padding: 0 5px;
    background-color: #dadada;
}

table.resultTable{
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    margin: auto;
}

td {
    padding: 5px;
}

tr{
    border-top: 1px solid #325674;
}

table.resultTable>tr:nth-child(odd){
    background-color: rgb(230, 230, 230);
}

@media(width < 900px){
    .bc-logo {
        margin-right: 20px;
    }

    .header-title{
        font-size: 18px;
    }

    .header-subtitle{
        font-size: 16px;
    }
    
    #disclaimer-div, #btn-export, table.resultTable{
        font-size: 12px;
    }
}

@media (width <= 600px) {
    .grid-container{
        display: grid;
        grid-template-columns: 1fr;
        padding: 5px;
    }

    .bc-logo {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        margin-left: 0;
        margin-right: 10px;
    }

    .header-title{
        font-size: 14px;
    }

    .header-subtitle, #btn-export, table.resultTable{
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gDAAuC;IACvC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;IACI,oCAAoC;IACpC,oCAAoC;IACpC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,gDAAuC;QACvC,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import \"https://js.arcgis.com/5.0/@arcgis/core/assets/esri/themes/light/main.css\";\r\n\r\nbody {\r\n    background-color: rgb(246, 246, 246);\r\n}\r\n\r\n#parent-div{\r\n    width: 80vw;\r\n    margin: auto;\r\n}\r\n\r\n#header {\r\n    background-color: #325674;\r\n    height: 15vh;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.header-title{\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n}\r\n\r\n.header-subtitle{\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 20px;\r\n}\r\n\r\n#header h1, h4{\r\n    color: white;\r\n    margin: 0;\r\n}\r\n\r\n.bc-logo {\r\n    content: url(\"BonnerCountyLogo-75.png\");\r\n    margin-left: 20px;\r\n    margin-right: 50px;\r\n}\r\n\r\n#disclaimer-div{\r\n    border: 1px solid rgb(219, 219, 219);\r\n    padding: 0 10px;\r\n    margin: 5px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n#last-updated-div{\r\n    font-size: 10px;\r\n    font-style: italic\r\n}\r\n\r\n#btn-export{\r\n    color: blue;\r\n    font-weight: bold;\r\n    font-size: 14px;\r\n}\r\n\r\n#btn-export:hover{\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}\r\n\r\n/* main[role=main]{\r\n    margin: auto;\r\n    width: 60vw;\r\n} */\r\n\r\n#mainContent-inner {\r\n    background-color: rgb(255, 255, 255);\r\n    border: 1px solid rgb(140, 140, 140);\r\n    padding: 10px;\r\n    min-height: 500px;\r\n    overflow-y: auto;\r\n    max-height: 65vh;\r\n}\r\n\r\n.grid-container{\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    padding: 5px;\r\n}\r\n\r\n#mainContent-inner>div:nth-child(odd){\r\n    padding: 0 5px;\r\n    background-color: #dadada;\r\n}\r\n\r\ntable.resultTable{\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 14px;\r\n    margin: auto;\r\n}\r\n\r\ntd {\r\n    padding: 5px;\r\n}\r\n\r\ntr{\r\n    border-top: 1px solid #325674;\r\n}\r\n\r\ntable.resultTable>tr:nth-child(odd){\r\n    background-color: rgb(230, 230, 230);\r\n}\r\n\r\n@media(width < 900px){\r\n    .bc-logo {\r\n        margin-right: 20px;\r\n    }\r\n\r\n    .header-title{\r\n        font-size: 18px;\r\n    }\r\n\r\n    .header-subtitle{\r\n        font-size: 16px;\r\n    }\r\n    \r\n    #disclaimer-div, #btn-export, table.resultTable{\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n@media (width <= 600px) {\r\n    .grid-container{\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        padding: 5px;\r\n    }\r\n\r\n    .bc-logo {\r\n        content: url(\"BonnerCountyLogo-45.png\");\r\n        margin-left: 0;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    .header-title{\r\n        font-size: 14px;\r\n    }\r\n\r\n    .header-subtitle, #btn-export, table.resultTable{\r\n        font-size: 12px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
